import React from "react";

// Router
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import PeopleReportView from "../../pages/PeopleReportView";
import UnAuthorizedPage from "../../pages/UnAuthorizedPage";

// Views
import App from "./App";

const routes = [
  { path: "/home", name: "Home", Component: App },
  {
    path: "/entityportal",
    name: "Entity Portal",
    Component: PeopleReportView,
  },
  {
    path: "/unauth",
    name: "UnAuthorizedPage",
    Component: UnAuthorizedPage,
  },
];

//parse and replace any dynamic constant with value from paramsLocal
const parseForDynamicRouteName = (crumbsObjMap, paramsLocal) => {
  let k = 0;
  crumbsObjMap.map(({ name, path }) => {
    if (typeof name === "string" && name.startsWith(":", 0)) {
      try {
        let tmpval = paramsLocal[name.substring(1)];
        if (tmpval === undefined) {
          console.warn("name ", name, " in params not found");
        } else {
          crumbsObjMap[k]["name"] = "" + tmpval;
          //console.log("updated ", name, " with ", tmpval)
        }
      } catch (e) {
        console.error(
          "parseForDynamicRouteName error with value replacement for name ",
          name,
          e
        );
      }
    }
    k++;
  });
};
// const Routes = () => {
//   return (
//     <Router>
//       <Switch>
//         {routes.map(({ path, name, Component }, key) => (
//           <Route
//             exact
//             path={path}
//             key={key}
//             render={(props) => {
//               //console.log("routes := ", routes)
//               const crumbs = routes
//                 // Get all routes that contain the current one.
//                 .filter(({ path }) => props.match.path.includes(path))
//                 // Swap out any dynamic routes with their param values.
//                 .map(({ path, ...rest }) => ({
//                   path: Object.keys(props.match.params).length
//                     ? Object.keys(props.match.params).reduce(
//                         (path, param) =>
//                           path.replace(`:${param}`, props.match.params[param]),
//                         path
//                       )
//                     : path,
//                   ...rest,
//                 }));

//               //console.log(`Generated crumbs for ${props.match.path}`)
//               //crumbs.map(({ name, path }) => console.log({ name, path }))

//               //parse and replace any dynamic constant with value from params
//               parseForDynamicRouteName(crumbs, props.match.params);

//               props.crumbs = crumbs;

//               return (
//                 <>
//                   <Component {...props} />
//                 </>
//               );
//             }}
//           />
//         ))}

//         {/* For non-existent route, redirect to home page */}
//         <Route
//           path="*"
//           component={() => {
//             window.location.href = window.origin + "/myproject-web/app#/";
//             return null;
//           }}
//         />
//       </Switch>
//     </Router>
//   );
// };

const Routes = () => {
  return (
    <Router>
      <Switch>
        {routes.map(({ path, name, Component }, key) => (
          <Route
            exact
            path={path}
            key={key}
            render={(props) => {
              //console.log("routes := ", routes)
              //   const crumbs = routes
              //     // Get all routes that contain the current one.
              //     .filter(({ path }) => props.match.path.includes(path))
              //     // Swap out any dynamic routes with their param values.
              //     .map(({ path, ...rest }) => ({
              //       path: Object.keys(props.match.params).length
              //         ? Object.keys(props.match.params).reduce(
              //             (path, param) =>
              //               path.replace(`:${param}`, props.match.params[param]),
              //             path
              //           )
              //         : path,
              //       ...rest,
              //     }));

              //   //parse and replace any dynamic constant with value from params
              //   parseForDynamicRouteName(crumbs, props.match.params);

              //   props.crumbs = crumbs;

              return (
                <>
                  <Component {...props} />
                </>
              );
            }}
          />
        ))}
        {/* For non-existent route, redirect to home page */}
        {/* <Route
          path="*"
          component={() => {
            window.location.href = window.origin + "/myproject-web/app#/";
            return null;
          }}
        /> */}
      </Switch>
    </Router>
  );
};

export default Routes;
